package org.hs_soft.runmynesto.pages.home.sub_page.options.mvi

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.errorMessage

import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.general_error_model.GeneralError
import org.hs_soft.runmynesto.domain.model.home.options.AllergensEnum
import org.hs_soft.runmynesto.domain.model.home.options.LanguageEnum
import org.hs_soft.runmynesto.domain.model.home.options.MenuCardEnum
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.DeviceTypeEnum
import org.hs_soft.runmynesto.domain.model.home.options.menu_card_import.menu_card_model.MenuCardModel
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.ObjectKinds
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.ShapeEnum
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project.Furniture
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project.RestaurantProject
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project.Room
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_allergen.ingeredient_list.Ingredients
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_product_general.sale_group.SaleItem
import org.hs_soft.runmynesto.domain.model.home.template.product_categories.TemplateCategoryModel
import org.hs_soft.runmynesto.domain.model.home.user.tabs.user_checkout.user_checkout_model.Children
import org.hs_soft.runmynesto.domain.requestHandler
import org.hs_soft.runmynesto.domain.usecase.home.GetSavedCheckOutUseCase
import org.hs_soft.runmynesto.domain.usecase.home.SaveCheckOutUseCase
import org.hs_soft.runmynesto.domain.usecase.home.SetNewCustomerUseCase
import org.hs_soft.runmynesto.domain.usecase.media_center.tabs.media.LoadAppConstantsUseCase
import org.hs_soft.runmynesto.domain.usecase.options.cash_flow.GetAppConfigUseCase
import org.hs_soft.runmynesto.domain.usecase.options.cash_flow.UpdateAppConfigUseCase
import org.hs_soft.runmynesto.domain.usecase.options.cash_register_config.*
import org.hs_soft.runmynesto.domain.usecase.options.export.*
import org.hs_soft.runmynesto.domain.usecase.options.printer_locatoin.UpdatePrinterLocationUseCase
import org.hs_soft.runmynesto.domain.usecase.options.menu_card_import.GetMenuCardUseCase
import org.hs_soft.runmynesto.domain.usecase.options.menu_card_import.UpsertProductsUseCase
import org.hs_soft.runmynesto.domain.usecase.options.operation.OptionDataUseCase
import org.hs_soft.runmynesto.domain.usecase.options.operation.UpdateOptionUseCase
import org.hs_soft.runmynesto.domain.usecase.options.price_category.UpdatePriceCategoriesUseCase
import org.hs_soft.runmynesto.domain.usecase.options.restaurant_manager.CreateFloorUseCase
import org.hs_soft.runmynesto.domain.usecase.options.restaurant_manager.CreateFurnitureUseCase
import org.hs_soft.runmynesto.domain.usecase.options.restaurant_manager.CreateRoomUseCase
import org.hs_soft.runmynesto.domain.usecase.options.restaurant_manager.DeleteFloorUseCase
import org.hs_soft.runmynesto.domain.usecase.options.restaurant_manager.DeleteFurnitureUseCase
import org.hs_soft.runmynesto.domain.usecase.options.restaurant_manager.DeleteRoomUseCase
import org.hs_soft.runmynesto.domain.usecase.options.restaurant_manager.RestaurantProjectsUseCase
import org.hs_soft.runmynesto.domain.usecase.options.restaurant_manager.UpdateFloorUseCase
import org.hs_soft.runmynesto.domain.usecase.options.restaurant_manager.UpdateFurnitureUseCase
import org.hs_soft.runmynesto.domain.usecase.options.restaurant_manager.UpdateRestaurantProjectUseCase
import org.hs_soft.runmynesto.domain.usecase.options.restaurant_manager.UpdateRoomUseCase
import org.hs_soft.runmynesto.domain.usecase.options.sales_group.AddNewSaleGroupUseCase
import org.hs_soft.runmynesto.domain.usecase.options.sales_group.SingleSaleGroupUseCase
import org.hs_soft.runmynesto.domain.usecase.options.sales_group.UpdateSaleGroupUseCase
import org.hs_soft.runmynesto.domain.usecase.options.virtual_card.GetVirtualCardInfoUseCase
import org.hs_soft.runmynesto.domain.usecase.options.virtual_card.UpdateVirtualCardInfoUseCase
import org.hs_soft.runmynesto.domain.usecase.product.AddProductUseCase
import org.hs_soft.runmynesto.domain.usecase.product.SaveCompanyProfileIdUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_click_collect.UpdateProductPropertiesUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_product_general.IngredientListUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_product_general.ProductSaleGroupUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_restaurant.PrinterLocationNamesUseCase
import org.hs_soft.runmynesto.domain.usecase.template.AddCategoryUseCase
import org.hs_soft.runmynesto.domain.usecase.template.GetTemplateCategoriesUseCase
import org.hs_soft.runmynesto.domain.usecase.template.tabs.tab_options.GetPriceLevelsUseCase
import org.hs_soft.runmynesto.domain.usecase.user.CheckOutDataUseCase
import org.hs_soft.runmynesto.domain.util.*
import org.hs_soft.runmynesto.domain.util.helper.BaseViewModel
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.w3c.files.File
import kotlin.math.min

class OptionsViewModel(
    private val requestManager: RequestManager,
    private val updatePrinterLocationUseCase: UpdatePrinterLocationUseCase,
    private val optionsDataUseCase: OptionDataUseCase,
    private val addNewSaleGroupUseCase: AddNewSaleGroupUseCase,
    private val singleSaleGroupUseCase: SingleSaleGroupUseCase,
    private val updateSaleGroupUseCase: UpdateSaleGroupUseCase,
    private val salesGroupUseCase: ProductSaleGroupUseCase,
    private val printerLocationNamesUseCase: PrinterLocationNamesUseCase,
    private val updateOptionUseCase: UpdateOptionUseCase,
    private val saveCompanyProfileIdUseCase: SaveCompanyProfileIdUseCase,
    private val appConfigUseCase: GetAppConfigUseCase,
    private val updateAppConfigUseCase: UpdateAppConfigUseCase,
    private val getCashRegisterConfigUseCase: GetCashRegisterConfigUseCase,
    private val updateCashRegisterConfigUseCase: UpdateCashRegisterConfigUseCase,
    private val updateVirtualCardInfoUseCase: UpdateVirtualCardInfoUseCase,
    private val getVirtualCardInfoUseCase: GetVirtualCardInfoUseCase,
    private val priceLevelsUseCase: GetPriceLevelsUseCase,
    private val getSavedCheckOutUseCase: GetSavedCheckOutUseCase,
    private val getMenuCardUseCase: GetMenuCardUseCase,
    private val restaurantProjectsUseCase: RestaurantProjectsUseCase,
    private val createFurnitureUseCase: CreateFurnitureUseCase,
    private val updateFurnitureUseCase: UpdateFurnitureUseCase,
    private val createFloorUseCase: CreateFloorUseCase,
    private val updateFloorUseCase: UpdateFloorUseCase,
    private val deleteFloorUseCase: DeleteFloorUseCase,
    private val deleteRoomUseCase: DeleteRoomUseCase,
    private val upsertProductsUseCase: UpsertProductsUseCase,
    private val addCategoryUseCase: AddCategoryUseCase,
    private val updateProductPropertiesUseCase: UpdateProductPropertiesUseCase,
    private val updateRoomUseCase: UpdateRoomUseCase,
    private val createRoomUseCase: CreateRoomUseCase,
    private val updateRestaurantProjectUseCase: UpdateRestaurantProjectUseCase,
    private val deleteFurnitureUseCase: DeleteFurnitureUseCase,
    private val createNewDepartmentUseCase: CreateNewDepartmentUseCase,
    private val saveCheckOutUseCase: SaveCheckOutUseCase,
    private val checkOutDataUseCase: CheckOutDataUseCase,
    private val createNewRegionUseCase: CreateNewRegionUseCase,
    private val createNewShopUseCase: CreateNewShopUseCase,
    private val createCashRegisterUseCase: CreateCashRegisterUseCase,
    private val setNewCustomerUseCase:SetNewCustomerUseCase,
    private val addProductUseCase: AddProductUseCase,
    private val apaleoPropertiesUseCase: ApaleoPropertiesUseCase,
    private val apaleoPaymentMethodUseCase: ApaleoPaymentMethodsUseCase,
    private val optionCreditCardUseCase: OptionCreditCardUseCase,
    private val cashRegisterGlobalUseCase: CashRegisterGlobalUseCase,
    private val updateCashRegisterGlobalUseCase: UpdateCashRegisterGlobalUseCase,
    private val getTemplateCategoriesUseCase: GetTemplateCategoriesUseCase,
    private val ingredientListUseCase: IngredientListUseCase,
    private val apaleoSubAccountsUseCase: ApaleoSubAccountsUseCase,
    private val tseLocationsUseCase:TSELocationsUseCase,
    private val loadAppConstantUseCase: LoadAppConstantsUseCase,
    private val aydenStoresUseCase: AydenStoresUseCase,
    private val listDeviceUseCase: ListDeviceUseCase,
    private val updatePriceCategoriesUseCase: UpdatePriceCategoriesUseCase,

):BaseViewModel() {

    private val _state = MutableStateFlow(OptionsState())
    val state: StateFlow<OptionsState> = _state
    private var tempSalesGroup:List<SaleItem> = listOf()
    private var tempCheckoutList:List<Children> ?= listOf()
    private var tempRestaurantProject:List<RestaurantProject?>?= listOf()

    override  fun clear() {
        super.clear()
        requestManager.cancelAll()
    }


   fun onEvent(event: OptionsEvent) {
        when(event){

            is OptionsEvent.UpdatePriceLevels->{
                updatePriceLevels(
                    prices=event.prices
                )
            }

            is OptionsEvent.DismissErrorDialog->{
                _state.value=_state.value.copy(
                    errorInfo = null,
                )
            }

            is OptionsEvent.OnFurnitureFocus->{
                onFurnitureFocus(
                    furniture=event.furniture
                )
            }

            is OptionsEvent.UpdateCashRegisterGlobal->{
                updateCashRegisterGlobal(
                    title=event.title,
                    value=event.value,
                )
            }
            is OptionsEvent.GetListDevices->{
                getListDevices()
            }
            is OptionsEvent.GetApaleoPaymentMethods->{
                getApaleoPaymentMethods()
            }

            is OptionsEvent.GetApaleoProperties->{
                getApaleoProperties()
            }
            is OptionsEvent.GetAydenStores->{
                getAydenStores()
            }
            is OptionsEvent.GetTSELocations->{
                getTSELocations(id=event.id)
            }
            is OptionsEvent.GetApaleoSubAccounts->{
                getApaleoSubAccounts(
                    propertyId = event.propertyId
                )
            }
            is OptionsEvent.GetCashRegisterGlobal->{
                getCashRegisterGlobal()
            }
            is OptionsEvent.GetOptionCreditCards->{
                getOptionCreditCards()
            }
            is OptionsEvent.GetApaleoPaymentMethods->{
                getApaleoPaymentMethods()
            }

            is OptionsEvent.GetApaleoProperties->{
                getApaleoProperties()
            }
            is OptionsEvent.OnCancelAddPrinterLocationDialog->{
                cancelPrinterLocation()
            }

            is OptionsEvent.SweepRestaurantPagesForTablet->{
                sweepRestaurantPageForTablet(event.firstPageActive)
            }
            is OptionsEvent.CreateCashRegister->{
                createNewCashRegister(
                    name=event.name,
                    deviceType=event.deviceType,
                    shopId=event.shopId,
                    hardwareId=event.hardwareId,
                    settingsCopyId=event.settingsCopyId,
                    deactivateAllContent=event.deactivateAllContent,
                )
            }
            is OptionsEvent.CreateNewShop->{
                createNewShop(
                    name=event.name,
                    regionId=event.regionId,
                )
            }


            is OptionsEvent.CreateNewRegion->{
                createNewRegion(
                    name=event.name,
                    departmentId=event.departmentId,
                )
            }
            is OptionsEvent.CreateNewDepartment->{
                createNewDepartment(name = event.name)
            }

            is OptionsEvent.SetAddNewDeviceToCashRegistersDialogStatus->{
                setAddNewDeviceToCashRegisterDialogStatus(
                    status=event.status
                )
            }

            is OptionsEvent.DeleteFurniture->{
                deleteFurniture(
                    id=event.id
                )
            }

            is OptionsEvent.CopyFurniture->{
                copyFurniture(furniture=event.furniture)
            }

            is OptionsEvent.InitFirstPageInRestaurantDesign->{
                _state.value=_state.value.copy(
                    firstPageActive = true
                )
            }

            is OptionsEvent.UpdateRestaurantProject->{
                updateRestaurantProject(
                    projectId=state.value.selectedRestaurantProject?.id,
                    caption=event.caption,
                )
            }

            is OptionsEvent.UpdateRestaurantRoom->{
                updateRestaurantRoom(
                    roomId=event.roomId,
                    caption=event.caption,
                )
            }


            is OptionsEvent.CreateRestaurantRoom->{
                createRestaurantRoom(
                    caption=event.caption,
                    floorId=event.floorId,
                    projectId=event.projectId,
                )
            }

            is OptionsEvent.DeleteRestaurantRoom->{
                deleteRestaurantRoom(roomId = event.roomId)
            }

            is OptionsEvent.DeleteRestaurantFloor->{
                deleteRestaurantFloor(floorId=event.floorId)
            }

            is OptionsEvent.SetDeleteFloorDialogStatus->{
                setDeleteFloorDialogStatus(
                    status=event.status,
                    selectedFloorId=event.floorId
                )
            }
            is OptionsEvent.SetDeleteRoomDialogStatus->{
                _state.value=_state.value.copy(
                    showDeleteRestaurantRoomDialog = event.status,
                    selectedRoomId=event.roomId
                )
            }


            is OptionsEvent.UpdateRestaurantFloor->{
                updateRestaurantFloor(
                    number=event.number,
                    floorId = event.floorId,
                )
            }

            is OptionsEvent.CreateRestaurantFloor->{
                createRestaurantFloor(
                    number=event.number,
                    projectId = state.value.selectedRestaurantProject?.id?:""
                )
            }

            is OptionsEvent.SetEditRestaurantFloorDialogStatus->{

                setEditRestaurantFloorDialogStatus(
                    status = event.status,
                    floorNumber =event.floorNumber,
                    floorId = event.floorId,
                )
            }

            is OptionsEvent.SetAddRestaurantFloorDialogStatus->{
                setAddRestaurantFloorDialogStatus(
                    status=event.status,
                )
            }

            is OptionsEvent.OnRestaurantFloorClick->{
                onRestaurantProjectFloorClick(model = event.restaurantProject)
            }

            is OptionsEvent.UpdateFurniture->{
                updateFurniture(
                    id=event.id,
                    height=event.height,
                    positionLeft=event.positionLeft,
                    positionTop=event.positionTop,
                    rotationDeg=event.rotationDeg,
                    width=event.width,
                    caption=event.caption,
                    componentColor=event.componentColor,
                )
            }

            is OptionsEvent.TransformFurniture->{
                transformFurniture(
                    id=event.id,
                    height=event.height,
                    positionLeft=event.positionLeft,
                    positionTop=event.positionTop,
                    rotationDeg=event.rotationDeg,
                    width=event.width,
                    objectKind=event.objectKind,
                )
            }

            is OptionsEvent.GetTemplateCategoryList ->{
                getTemplateCategoryList( )

            }

            is OptionsEvent.UpdateTemplateCategoryList ->{
                updateTemplateCategoryList(
                    categoriesDropDown = event.categoriesDropDown,
                    menuCard = event.menuCard
                )

            }

            is OptionsEvent.OnRestaurantRoomClick->{
                onRestaurantRoomClick(
                    room=event.room,
                    restaurantProject=event.restaurantProject,
                    switchThePageForMobileAndTabletMode=event.switchThePageForMobileAndTabletMode,
                )
            }

            is OptionsEvent.CreateFurniture ->{
                createFurniture(
                    componentColor =event.componentColor,
                    floorId =state.value.selectedRestaurantRoom?.floorId?:"" ,
                    roomId =state.value.selectedRestaurantRoom?.id?:"" ,
                    projectId =state.value.selectedRestaurantRoom?.projectId?:"",
                    shape=event.shape,
                    number = event.number,
                    objectKind = event.objectKind,
                )
            }

            is OptionsEvent.OnRestaurantDesignTableColorClick->{
                onRestaurantDesignTableColorClick(color = event.color)
            }

            is OptionsEvent.SetRestaurantTableColorDialogStatus->{
                showChooseRestaurantTableColorDialog(event.status)
            }

            is OptionsEvent.OnSearchInRestaurantProject->{
                searchInRestaurantProject(title=event.title)
            }

            is OptionsEvent.OnRestaurantProjectClick->{
                onRestaurantProjectClick(model=event.model)
            }

            is OptionsEvent.GetRestaurantProjects->{
                getRestaurantProjects()
            }

            is OptionsEvent.OnSelectShop->{
                _state.value=_state.value.copy(
                    selectedBranch = event.branch
                )
            }

            is OptionsEvent.OnSelectRegion -> {
                _state.value = _state.value.copy(
                    selectedRegion = event.region,
                    selectedBranch = if (event.region?.children?.isNotEmpty() == true)
                        event.region.children[0] else null
                )
            }

            is OptionsEvent.OnSelectOffice -> {

                _state.value = _state.value.copy(
                    selectedOffice = event.office,
                    selectedRegion = if (event.office?.children?.isNotEmpty() == true)
                        event.office.children[0] else null,
                    selectedBranch = if (event.office?.children?.isNotEmpty() == true &&
                        !event.office.children[0].children.isNullOrEmpty())
                        event.office.children[0].children?.get(0) else null
                )
            }

            is OptionsEvent.GetPriceLevels->{
                getPriceLevels()
            }



            is OptionsEvent.OnColorBoxClick->{
                _state.value=_state.value.copy(
                    showVirtualCardColorPalletDialog = true,
                    selectedColorField=event.selectedColorField,
                )
            }

            is OptionsEvent.SetColorPalletStatus->{
                _state.value=_state.value.copy(
                    showVirtualCardColorPalletDialog = event.status
                )
            }

            is OptionsEvent.OnVirtualCardPalletColorClick->{
                onPalletColorClick(
                    virtualCardHexColor = event.hexColor,
                )
            }

            is OptionsEvent.GetVirtualCardInfo->{
                getVirtualCardInfo()
            }

            is OptionsEvent.OnCashRegisterConfigTabClick->{
                _state.value=_state.value.copy(
                    selectedCashRegisterConfigTab = event.tab
                )
            }

            is OptionsEvent.OnCloseGoogleWallet->{
                _state.value=_state.value.copy(showGoogleWalletDialog = false)
            }
            is OptionsEvent.OnPreviewGoogleWalletClick->{
                _state.value=_state.value.copy(showGoogleWalletDialog=true)
            }

            is OptionsEvent.OnCloseAppleWallet->{
                _state.value=_state.value.copy(showAppleWalletDialog =false)
            }
            is OptionsEvent.OnPreviewAppleWalletClick->{
                _state.value=_state.value.copy(showAppleWalletDialog=true)
            }

            is OptionsEvent.UpdateCashRegisterConfigData -> {
                updateCashRegisterConfig(
                    id = state.value.selectedCashRegisterConfigItemId ,
                    title = event.title,
                    value = event.value,
                    valueIsInParameters = event.valueIsInParameters ?: true,
                    isKotlinApi = event.isKotlinApi,
                    configsList = event.configsList
                )
            }

            is OptionsEvent.OnCashRegisterConfigItemClick->{
                onCashRegisterConfigItemClick(
                    id=event.id,
                )
            }



            is OptionsEvent.GetCheckoutData->{
                getCheckoutData()
            }

            is OptionsEvent.OnSearchCheckoutItems->{
                searchCheckoutItems(value=event.value)
            }

            is OptionsEvent.UpdateAppConfig->{
                updateAppConfig(
                    title=event.title,
                    value=event.value,
                )
            }

            is OptionsEvent.GetAppConfig->{
                getAppConfig()
            }

            is OptionsEvent.UpdateVirtualCardInfo->{
                updateVirtualCardInfo(
                    dataTitle=event.dataTitle,
                    dataValue=event.dataValue,
                )
            }

            is OptionsEvent.GetIngredients->{
                getIngredients()
            }

            is OptionsEvent.OnLoadingOperationData->{
                loadOperationData()
            }

            is OptionsEvent.UpdateOptionData->updateOptionData(
                dataTitle = event.dataTitle,
                dataValue = event.dataValue,
            )


            is OptionsEvent.OnTopTabClick->{
                if (state.value.areTabsClickable){
                    _state.value=_state.value.copy(selectedTab = event.tab)
                }

            }

            is OptionsEvent.GetProductSalesGroup ->{
                if (state.value.productSalesGroup==null){
                    getSalesGroup(onClickAction = event.onSaleGroupItemClickAction)
                }

            }

            is OptionsEvent.OnSaleGroupItemClick ->onSaleGroupItemClick(
                id=event.id,
                switchTheSecondPage=event.callBack,
            )

            is OptionsEvent.OnSearchSaleGroupInputChange->{
                onSearchSaleGroupInputChange(value = event.value)
            }

            is OptionsEvent.OnSaleGroupTitleSortClick->{
                onSaleGroupTitleSortClick()
            }

            is OptionsEvent.OnSaleGroupNumberSortClick->{
                onSaleGroupNumberSortClick()
            }



            is OptionsEvent.OnChangePageClick->{
                changePage()
            }

            is OptionsEvent.UpdateSaleGroup->{
                updateSaleGroup(
                    dataTitle=event.dataTitle,
                    dataValue=event.dataValue,
                    id=state.value.selectedSaleGroup?.id?:""
                )
            }


            //Add Record
            is OptionsEvent.OnAddRecordDialogBackgroundClick->{
                dismissAddRecordDialog()
            }

            is OptionsEvent.OnAddRecordIconClick->onAddRecordIconClick()

            is OptionsEvent.OnCancelAddSaleGroupDialogClick->dismissAddRecordDialog()

            is OptionsEvent.OnChangeRecordName->onChangeRecordName(
                value = event.value,
                isNumberOptional = event.isNumberOptional
            )
            is OptionsEvent.OnChangeRecordNumber->onChangeRecordNumber(event.value)

            is OptionsEvent.OnSubmitAddSaleGroupRecordDialogClick->{
                onSubmitSaleGroupRecordDialogClick(
                    windowMode = event.windowMode,
                    name=state.value.newRecordName?:"",
                    code =state.value.newRecordNumber,
                )
            }


            is OptionsEvent.RefreshSaleGroupList->{
                getSalesGroup()
            }

            is OptionsEvent.GetPrintersLocation->{
                getPrintersLocation()
            }

            is OptionsEvent.ShowAddPrinterLocationRecordDialog->{
                _state.value=_state.value.copy(
                    showPrinterLocationRecordDialog = true
                )
            }

            is OptionsEvent.AddPrinterLocationRecord->{
                addPrinterLocationRecord(location = event.location)

            }

            is OptionsEvent.ShowUpdatePrinterLocationRecordDialog->{
                showUpdatePrinterLocationRecordDialog(
                    name = event.name,
                    dbIndex = event.dbIndex,
                )
            }

            is OptionsEvent.OnSubmitUpdatePrinterLocationRecordDialogClick->{

                submitUpdateKitchenLocationRecordDialog(location = event.location)

            }

            is OptionsEvent.SetGenerateAIMenuCardDialogStatus->{
                setGenerateAIMenuCardDialogStatus(status=event.status)
            }

            is OptionsEvent.ResetGenerateAIMenuCard->{
                resetGeneratedAIMenuCard()
            }

            is OptionsEvent.GenerateMenuCard->{
                generateMenuCard(
                    email=event.email,
                    files=event.files,
                )
            }

            is OptionsEvent.SaveMenuCard->{
                saveMenuCard(
                    menuCard=event.menuCard,
                    ingredients = event.ingredients
                )
            }

            is OptionsEvent.OnMenuProductItemValueChange->{
                onMenuProductItemValueChange(
                    event.menuCard,
                    event.id,
                    event.key,
                    event.value
                )
            }

            is OptionsEvent.OnGenerateMenuCardButtonClick->onGenerateMenuCardButtonClick()

            is OptionsEvent.OnAddPDFFile->{
                _state.value=_state.value.copy(
                    menuCardPDFFilesUploaded = event.count,
                )
            }

            is OptionsEvent.OnAddImageFile->{
                _state.value=_state.value.copy(
                    menuCardImageFilesUploaded = event.count,
                )
            }

            is OptionsEvent.OnMenuCardFilesSelect->{
                _state.value=_state.value.copy(
                    menuCardSelectedFiles = event.selectedFiles
                )
            }

            is OptionsEvent.OnCashRegisterConfigHardwareTabClick -> {
                _state.value = _state.value.copy(
                    selectedCashRegisterConfigHardwareTab = event.tab
                )
            }

        }

    }

    private fun updatePriceLevels(prices: List<String?>) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(isLoading = isLoading)
                },
                callRequest = {
                    updatePriceCategoriesUseCase(prices=prices)

                },
                onSuccess = { result ->
                    getPriceLevels(refresh = true)
//                    _state.value = _state.value.copy(
//                        priceLevels = result.data?.cashAssist?.
//                            updateAppConfigAdditional?.priceLevels?: listOf()
//                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }

    }


    private fun onFurnitureFocus(furniture: Furniture?) {
        _state.value=_state.value.copy(
            selectedFurniture=furniture,
            selectedRestaurantDesignTableColor=furniture?.componentColor
        )
    }

    private fun getApaleoProperties() {
        if (state.value.apaleoProperties == null) {
            launch {
                requestHandler(
                    loadingState = { isLoading ->
                        _state.value = _state.value.copy(isLoading = isLoading)
                    },
                    callRequest = {
                        apaleoPropertiesUseCase()

                    },
                    onSuccess = { result ->
                        _state.value = _state.value.copy(
                            apaleoProperties = result.data?.cashAssist?.listApaleoProperties
                        )
                    },
                    onError = { result ->
                        showRequestError(result.errors)
                    },
                    onException = { e ->
                        showException(e)
                    }
                )
            }
        }
    }

    private fun getAydenStores() {
        launch {
            if (state.value.aydenStores == null) {
                requestHandler(
                    loadingState = { isLoading ->
                        _state.value = _state.value.copy(isLoading = isLoading)
                    },
                    callRequest = {
                        aydenStoresUseCase()
                    },
                    onSuccess = { result ->
                        _state.value = _state.value.copy(
                            aydenStores = result.data?.cashAssist?.listAdyenStores
                        )
                    },
                    onError = { result ->
                        showRequestError(result.errors)
                    },
                    onException = { e ->
                        showException(e)
                    }
                )
            }
        }
    }

    private fun getApaleoPaymentMethods() {
        launch {
            requestHandler(
                condition = state.value.apaleoPaymentMethods == null,
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(isLoading = isLoading)
                },
                callRequest = {
                    apaleoPaymentMethodUseCase()
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        apaleoPaymentMethods = result.data?.cashAssist?.listApaleoPaymentMethods
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }

    }


    private fun getTSELocations(id: String) {
        launch {
            requestHandler(
                condition =state.value.tseLocations == null ,
                callRequest = {
                    tseLocationsUseCase(id = id)
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        tseLocations = result.data?.cashAssist?.getShop
                            ?.cashRegisters ?: listOf()
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }

    }

    private fun getPaymentTerminalTypes() {
        launch {
                requestHandler(
                    condition =state.value.paymentTerminalTypes == null ,
                    callRequest = {
                        loadAppConstantUseCase(
                            type = IdUtils.paymentTerminalType,
                            language = LanguageEnum.German.name
                        )
                    },
                    onSuccess = { result ->
                        _state.value = _state.value.copy(
                            paymentTerminalTypes = result.data?.cashAssist?.loadAppConstants
                        )
                    },
                    onError = { result ->
                        showRequestError(result.errors)
                    },
                    onException = { e ->
                        showException(e)
                    }
                )
            }

    }

    private fun getApaleoSubAccounts(propertyId: String) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(isLoading = isLoading)
                },
                callRequest = {
                    apaleoSubAccountsUseCase(propertyId = propertyId)
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        apaleoSubAccounts = result.data?.cashAssist
                            ?.listApaleoSubAccounts ?: listOf()
                    )
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun getListDevices() {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(isLoading = isLoading)
                },
                callRequest = {
                    listDeviceUseCase(model = ApiUtils.Field.SUNMI_CLOUD_PRINTER)
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        listDevices = result.data?.listDevices?.items
                    )
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun updateCashRegisterGlobal(
        title: String,
        value: dynamic
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(isLoading = isLoading)
                },
                callRequest = {
                    updateCashRegisterGlobalUseCase(
                        title = title,
                        value = value
                    )
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        cashRegisterGlobal = result.data?.cashAssist
                            ?.updateAppConfig?.cashRegisterGlobal
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun getCashRegisterGlobal() {

        launch {
                requestHandler(
                    condition =state.value.cashRegisterGlobal == null ,
                    loadingState = { isLoading ->
                        _state.value = _state.value.copy(isLoading = isLoading)
                    },
                    callRequest = {
                        cashRegisterGlobalUseCase()
                    },
                    onSuccess = { result ->
                        _state.value = _state.value.copy(
                            cashRegisterGlobal = result.data?.cashAssist?.getAppConfig?.cashRegisterGlobal
                        )
                    },
                    onError = { result ->
                        showRequestError(result.errors)
                    },
                    onException = { e ->
                        showException(e)
                    }
                )
            }

    }

    private fun getOptionCreditCards() {
        launch {
                requestHandler(
                    condition =state.value.optionCreditCards == null ,
                    loadingState = { isLoading ->
                        _state.value = _state.value.copy(isLoading = isLoading)
                    },
                    callRequest = {
                        optionCreditCardUseCase()
                    },
                    onSuccess = { result ->
                        _state.value = _state.value.copy(
                            optionCreditCards = result.data?.cashAssist?.getAppConfig?.creditCards
                        )
                    },
                    onError = { result ->
                        showRequestError(result.errors)
                    },
                    onException = { e ->
                        showException(e)
                    }
                )
            }

    }

    private fun createNewCashRegister(
        name: String,
        deviceType: DeviceTypeEnum,
        shopId: String,
        hardwareId: String,
        settingsCopyId: String,
        deactivateAllContent: Boolean,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(addNewCashRegisterLoading = isLoading)
                },
                callRequest = {
                    createCashRegisterUseCase(
                        name = name,
                        deviceType = deviceType.id,
                        shopId = shopId,
                        hardwareId = hardwareId,
                        settingsCopyId = settingsCopyId,
                        deactivateAllContent = deactivateAllContent,
                    )
                },
                onSuccess = { _ ->
                    getAndSaveCheckoutData()
                    _state.value = _state.value.copy(
                        showAddNewDeviceToCashRegistersDialog = false
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                   showException(e)
                }
            )
        }
    }

    private fun createNewShop(
        name: String,
        regionId: String,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(addNewCashRegisterLoading = isLoading)
                },
                callRequest = {
                    createNewShopUseCase(
                        name = name,
                        regionId = regionId
                    )
                },
                onSuccess = { _ ->
                    getAndSaveCheckoutData()
                    _state.value = _state.value.copy(
                        showAddNewDeviceToCashRegistersDialog = false
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun createNewRegion(
        name: String,
        departmentId: String,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(addNewCashRegisterLoading = isLoading)
                },
                callRequest = {
                    createNewRegionUseCase(
                        name = name,
                        departmentId = departmentId
                    )
                },
                onSuccess = { _ ->
                    getAndSaveCheckoutData()
                    _state.value = _state.value.copy(
                        showAddNewDeviceToCashRegistersDialog = false
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun getAndSaveCheckoutData() {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(isLoading = isLoading)
                },
                callRequest = {
                    checkOutDataUseCase()
                },
                onSuccess = { result ->
                    launch {
                        saveCheckOutUseCase(model = result)
                    }

                    _state.value = _state.value.copy(
                        cashList = result.data.cashAssist?.children,
                        selectedRegion = null,
                        selectedBranch = null,
                        selectedOffice = null
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun createNewDepartment(
        name: String,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(addNewCashRegisterLoading = isLoading)
                },
                callRequest = {
                    createNewDepartmentUseCase(name = name)
                },
                onSuccess = {
                    getAndSaveCheckoutData()
                    _state.value = _state.value.copy(
                        showAddNewDeviceToCashRegistersDialog = false
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun copyFurniture(furniture: Furniture) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(isLoading = isLoading)
                },
                callRequest = {
                    createFurnitureUseCase(
                        caption = furniture.caption,
                        componentColor = furniture.componentColor,
                        floorId = furniture.floorId ?: "",
                        height = furniture.height ?: 0,
                        objectKind = furniture.objectKind ?: "",
                        objectType = furniture.objectType ?: "",
                        projectId = furniture.projectId ?: "",
                        roomId = furniture.roomId ?: "",
                        shape = furniture.shape ?: "",
                        width = furniture.width ?: 0,
                        positionTop = 10,
                        positionLeft = 10
                    )
                },
                onSuccess = {
                    getRestaurantProjects(refresh = true)
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun deleteFurniture(id: String?) {
        if (id != null) {
            launch {
                requestHandler(
                    loadingState = { isLoading ->
                        _state.value = _state.value.copy(isLoading = isLoading)
                    },
                    callRequest = {
                        deleteFurnitureUseCase(furnitureId = id)
                    },
                    onSuccess = {
                        getRestaurantProjects(refresh = true)
                    },
                    onError = { result ->
                        showRequestError(result.errors)
                    },
                    onException = { e ->
                        showException(e)
                    }
                )
            }
        }
    }


    private fun updateRestaurantProject(
        projectId: String?,
        caption: String,
    ) {
        if (projectId != null && caption.trim().isNotEmpty()) {
            launch {
                requestHandler(
                    loadingState = { isLoading ->
                        _state.value = _state.value.copy(isLoading = isLoading)
                    },
                    callRequest = {
                        updateRestaurantProjectUseCase(
                            caption = caption,
                            id = projectId
                        )
                    },
                    onSuccess = {
                        getRestaurantProjects(refresh = true)
                    },
                    onError = { result ->
                        showRequestError(result.errors)
                    },
                    onException = { e ->
                        showException(e)
                    }
                )
            }
        }
    }

    private fun createRestaurantRoom(
        caption: String,
        floorId: String,
        projectId: String,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(isLoading = isLoading)
                },
                callRequest = {
                    createRoomUseCase(
                        caption = caption,
                        floorId = floorId,
                        projectId = projectId
                    )
                },
                onSuccess = {
                    getRestaurantProjects(refresh = true)
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun updateRestaurantRoom(
        roomId: String,
        caption: String
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(isLoading = isLoading)
                },
                callRequest = {
                    updateRoomUseCase(
                        caption = caption,
                        roomId = roomId
                    )
                },
                onSuccess = {
                    getRestaurantProjects(refresh = true)
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun deleteRestaurantFloor(
        floorId: String?,
    ) {
        if (floorId != null) {
            launch {
                requestHandler(
                    loadingState = { isLoading ->
                        _state.value = _state.value.copy(
                            deleteRestaurantFloorLoading = isLoading)
                    },
                    callRequest = {
                        deleteFloorUseCase(floorId = floorId)
                    },
                    onSuccess = {
                        _state.value = _state.value.copy(
                            showDeleteRestaurantFloorDialog = false)
                        getRestaurantProjects(refresh = true)
                    },
                    onError = { result ->
                        showRequestError(result.errors)
                    },
                    onException = { e ->
                        showException(e)
                    }
                )
            }
        }
    }

    private fun updateRestaurantFloor(
        number: Int,
        floorId: String?
    ) {
        if (floorId != null) {
            launch {
                requestHandler(
                    loadingState = { isLoading ->
                        _state.value = _state.value.copy(editRestaurantFloorLoading = isLoading)
                    },
                    callRequest = {
                        updateFloorUseCase(
                            number = number,
                            floorId = floorId
                        )
                    },
                    onSuccess = {
                        getRestaurantProjects(refresh = true)
                    },
                    onError = { result ->
                        showRequestError(result.errors)
                    },
                    onException = { e ->
                        showException(e)
                    }
                )
            }
        }
    }

    private fun createRestaurantFloor(
        number: Int,
        projectId: String,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(addRestaurantFloorLoading = isLoading)
                },
                callRequest = {
                    createFloorUseCase(
                        number = number,
                        projectId = projectId
                    )
                },
                onSuccess = {
                    getRestaurantProjects(refresh = true)
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun updateFurniture(
        id: String?,
        height: Int?,
        positionLeft: Int?,
        positionTop: Int?,
        rotationDeg: Int?,
        width: Int?,
        caption: String?,
        componentColor: String?
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading -> },
                callRequest = {
                    if (id != null) {
                        updateFurnitureUseCase(
                            id = id,
                            height = height,
                            positionLeft = positionLeft,
                            positionTop = positionTop,
                            rotationDeg = rotationDeg,
                            width = width,
                            caption = caption,
                            componentColor = componentColor
                        )
                    } else {
                        null
                    }
                },
                onSuccess = { result ->
                    getRestaurantProjects(
                        refresh =true,
                        refreshSelectedRoom = componentColor != null || caption != null,
                        refreshSelectedProject = true,
                        showLoading = false,
                    )
                },
                onError = { result ->
                    showRequestError(result?.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun transformFurniture(
        id: String?,
        height: Int,
        positionLeft: Int,
        positionTop: Int,
        rotationDeg: Int,
        width: Int,
        objectKind: String?,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->},
                callRequest = {
                    if (id != null) {
                        updateFurnitureUseCase(
                            id = id,
                            height = height,
                            positionLeft = positionLeft,
                            positionTop = positionTop,
                            rotationDeg = rotationDeg,
                            width = width
                        )
                    } else {
                        null
                    }
                },
                onSuccess = {
                    getRestaurantProjects(
                        refresh = true,
                        refreshSelectedRoom = objectKind == ObjectKinds.BAR.value,
                        showLoading = false,
                    )
                },
                onError = { result ->
                    showRequestError(result?.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun deleteRestaurantRoom(roomId: String?) {
        if (roomId != null) {
            launch {
                requestHandler(
                    loadingState = { isLoading ->
                        _state.value = _state.value.copy(deleteRestaurantRoomLoading = isLoading)
                    },
                    callRequest = {
                        deleteRoomUseCase(roomId = roomId)
                    },
                    onSuccess = { result ->
                        _state.value = _state.value.copy(showDeleteRestaurantRoomDialog = false)
                        getRestaurantProjects(refresh = true)
                    },
                    onError = { result ->
                        _state.value = _state.value.copy(errorMessage = errorMessage(result.errors))
                        showRequestError(result.errors)
                    },
                    onException = { e ->
                        showException(e)
                    }
                )
            }
        }
    }

    private fun createFurniture(
        componentColor: String?,
        number: String?,
        floorId: String,
        roomId: String,
        projectId: String,
        shape: ShapeEnum,
        objectKind: ObjectKinds,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(isLoading = isLoading)
                },
                callRequest = {
                    createFurnitureUseCase(
                        caption = number,
                        componentColor = componentColor,
                        floorId = floorId,
                        height = objectKind.height,
                        width = objectKind.width,
                        objectKind = objectKind.value,
                        objectType = Constants.RestaurantDesign.objectType,
                        positionLeft = 100,
                        positionTop = 100,
                        projectId = projectId,
                        roomId = roomId,
                        shape = shape.value
                    )
                },
                onSuccess = {
                    getRestaurantProjects(refresh = true)
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }


    private fun resetGeneratedAIMenuCard() {
        _state.value = _state.value.copy(
            menuCardAIGenerated = MenuCardModel(
                categories = mutableListOf(),
                items = mutableListOf()
            ),
            clearMenuCardDataLoading=false
        )
        addCategoryUseCase.cancel()

    }


    private fun setGenerateAIMenuCardDialogStatus(status: Boolean) {
        _state.value = _state.value.copy(
            showGenerateAIMenuCardDialog =status,
            menuCardPDFFilesUploaded = 0,
            menuCardImageFilesUploaded = 0
        )
        if (!status)
        {
            getMenuCardUseCase.cancel()
            _state.value=_state.value.copy(
                isMenuCardAIGeneratorLoading = false
            )
        }
    }

    private fun setAddNewDeviceToCashRegisterDialogStatus(status: Boolean) {
        _state.value = _state.value.copy(
            showAddNewDeviceToCashRegistersDialog = status,
            addNewCashRegisterLoading = false
        )
    }

    private fun cancelPrinterLocation() {
        _state.value = _state.value.copy(
            showPrinterLocationRecordDialog = false,
            newRecordName = "",
            addNewPrinterLocationLoading = false
        )
        updatePrinterLocationUseCase.cancel()

    }

    private fun sweepRestaurantPageForTablet(firstPageActive: Boolean) {
        _state.value=_state.value.copy(firstPageActive=firstPageActive)
    }




    private fun setEditRestaurantFloorDialogStatus(
        status:Boolean,
        floorId: String?,
        floorNumber:Int?,
    ) {
        _state.value = _state.value.copy(
            showEditFloorDialog = status,
            selectedFloorId = if ( status)  floorId else null,
            selectedFloorNumberForEdit = if ( status)  floorNumber else null,
        )
    }

    private fun setDeleteFloorDialogStatus(
        status: Boolean,
        selectedFloorId: String?,
    ) {
        _state.value=_state.value.copy(
            showDeleteRestaurantFloorDialog =status,
            selectedFloorId = selectedFloorId
        )

    }



    private fun setAddRestaurantFloorDialogStatus(
        status: Boolean,
    ) {
        _state.value=_state.value.copy(
            showAddFloorDialog = status
        )
    }



    private fun onRestaurantRoomClick(
        room: Room?,
        restaurantProject: RestaurantProject?,
        switchThePageForMobileAndTabletMode:Boolean=false,
    )
    {
        _state.value=_state.value.copy(
            selectedRestaurantRoom =room,
            selectedRestaurantProject = restaurantProject,
            firstPageActive = !switchThePageForMobileAndTabletMode
        )
    }


    private fun onRestaurantDesignTableColorClick(color:String,) {
        _state.value = _state.value.copy(
            selectedRestaurantDesignTableColor=color,
            showChooseRestaurantTableColorDialog = false
        )

    }

    private fun showChooseRestaurantTableColorDialog(
        status:Boolean,
    ) {
        _state.value=_state.value.copy(
            showChooseRestaurantTableColorDialog=status,
        )
    }

    private fun searchInRestaurantProject(
        title: String,
    ) {
        _state.value= _state.value.copy(
            restaurantProjects =tempRestaurantProject
        )
        val searchedList = ArrayList<RestaurantProject?>()
        state.value.restaurantProjects?.forEach { model ->
            var matchFound = model?.caption?.lowercase()?.contains(title.lowercase()) ?: false

            model?.floors?.forEach { floor ->
                if ("${floor?.typename} ${floor?.number}".lowercase().contains(title.lowercase())) {
                    matchFound = true
                }
                floor?.rooms?.forEach { room ->
                    if (room?.caption?.lowercase()?.contains(title.lowercase()) == true) {
                        matchFound = true
                    }
                }
            }
            if (matchFound) {
                searchedList.add(model)
            }
        }


        _state.value=_state.value.copy(
            restaurantProjects = searchedList
        )


    }

    private fun onRestaurantProjectClick(model: RestaurantProject?) {
        if (state.value.selectedRestaurantProject?.id!=model?.id){
             _state.value=_state.value.copy(
                 selectedRestaurantProject = model,
                 selectedRestaurantRoom = null,
             )
        }

    }
    private fun onRestaurantProjectFloorClick(model: RestaurantProject?) {
        if (state.value.selectedRestaurantProject?.id!=model?.id){
            _state.value=_state.value.copy(
                selectedRestaurantProject = model,
                selectedRestaurantRoom = null,
            )
        }

    }

    private fun getRestaurantProjects(
        refresh: Boolean = false,
        refreshSelectedProject: Boolean = true,
        refreshSelectedRoom: Boolean = true,
        showLoading:Boolean=true,
    ) {
        if (state.value.restaurantProjects == null || refresh) {
            launch {
                requestHandler(
                    loadingState = { isLoading ->
                        _state.value = _state.value.copy(isLoading =if (showLoading)
                            isLoading else false)
                    },
                    callRequest = {
                        restaurantProjectsUseCase()
                    },
                    onSuccess = { result ->
                        val projects = result.data?.cashAssist?.listRestaurantProject ?: listOf()
                        _state.value = _state.value.copy(
                            restaurantProjects = projects,
                            showAddFloorDialog = false,
                            showEditFloorDialog = false
                        )
                        tempRestaurantProject = state.value.restaurantProjects

                        if (refreshSelectedProject) {
                            _state.value = _state.value.copy(
                                selectedRestaurantProject = projects
                                    .find { it?.id == state.value.selectedRestaurantProject?.id }
                            )
                        }

                        if (refreshSelectedRoom) {
                            _state.value = _state.value.copy(
                                selectedRestaurantRoom = projects
                                    .find { it?.id == state.value.selectedRestaurantProject?.id }
                                    ?.floors?.find { it?.id == state.value.selectedRestaurantRoom?.floorId }
                                    ?.rooms?.find { it?.id == state.value.selectedRestaurantRoom?.id }
                            )
                        }
                    },
                    onError = { result ->
                        showRequestError(result.errors)
                    },
                    onException = { e ->
                        showException(e)
                    }
                )
            }
        }
    }

    private fun getPriceLevels(
        refresh:Boolean=false,
    ) {
        launch {
                requestHandler(
                    condition = state.value.priceLevels == null || refresh,
                    loadingState = { isLoading ->
                        _state.value = _state.value.copy(isLoading = isLoading)
                    },
                    callRequest = {
                        priceLevelsUseCase()
                    },
                    onSuccess = { result ->
                        _state.value = _state.value.copy(
                            priceLevels = result.data?.cashAssist?.getAppConfigAdditional?.priceLevels
                        )
                    },
                    onError = { result ->
                        showRequestError(result.errors)
                    },
                    onException = { e ->
                        showException(e)
                    }
                )
            }

    }

    private fun getVirtualCardInfo() {
        if (state.value.virtualCardInfo == null) {
            launch {
                requestHandler(
                    loadingState = { isLoading ->
                        _state.value = _state.value.copy(isLoading = isLoading)
                    },
                    callRequest = {
                        getVirtualCardInfoUseCase()
                    },
                    onSuccess = { result ->
                        _state.value = _state.value.copy(
                            virtualCardInfo = result.data?.cashAssist?.getVirtualCardConfig
                        )
                    },
                    onError = { result ->
                        showRequestError(result.errors)
                    },
                    onException = { e ->
                        showException(e)
                    }
                )
            }
        }
    }

    private fun updateCashRegisterConfig(
        id: String?,
        title: String,
        value: dynamic,
        valueIsInParameters: Boolean,
        isKotlinApi: Boolean,
        configsList: List<Pair<String, dynamic>>
    ) {
        if (id != null) {
            launch {
                requestHandler(
                    loadingState = { isLoading ->
                        _state.value = _state.value.copy(isLoading = isLoading)
                    },
                    callRequest = {
                        updateCashRegisterConfigUseCase(
                            id = id,
                            title = title,
                            value = value,
                            valueIsInParameters = valueIsInParameters,
                            isKotlinApi = isKotlinApi,
                            configsList = configsList
                        )
                    },
                    onSuccess = { result ->
                        _state.value = _state.value.copy(
                            selectedCashRegisterConfigData = result.first.data
                                ?.cashAssist?.updateCashRegister,
                            newCashRegisterConfigData = result.second
                        )
                    },
                    onException = { e ->
                        showException(e)
                    }
                )
            }
        }
    }

    private fun onCashRegisterConfigItemClick(id: String?)
    {
        if (id != state.value.selectedCashRegisterConfigItemId) {
            _state.value = _state.value.copy(
                firstPageActive = !state.value.firstPageActive
            )

            launch {
                requestHandler(
                    loadingState = { isLoading ->
                        _state.value = _state.value.copy(isLoading = isLoading)
                    },
                    callRequest = {
                        getCashRegisterConfigUseCase(id = id.orEmpty())
                    },
                    onSuccess = { result ->
                        _state.value = _state.value.copy(
                            newCashRegisterConfigData = result.second,
                            selectedCashRegisterConfigData = result.first.data
                                ?.cashAssist?.getCashRegister,
                            selectedCashRegisterConfigItemId = result.first.data
                                ?.cashAssist?.getCashRegister?.id
                        )
                    },
                    onException = { e ->
                        showException(e)
                    }
                )
            }
        }
    }


    private fun onPalletColorClick(
        virtualCardHexColor:String,
    ) {
        _state.value = _state.value.copy(
            showVirtualCardColorPalletDialog = false
        )
        updateVirtualCardInfo(
            dataTitle = state.value.selectedColorField?:"",
            dataValue = virtualCardHexColor,
        )
    }

    private fun showUpdatePrinterLocationRecordDialog(
        dbIndex:Int?,
        name:String?,
    ) {
        _state.value = _state.value.copy(
            showPrinterLocationRecordDialog = true,
            printerLocationIndex = dbIndex,
            newRecordName = name ?: ""
        )
    }

    private fun addPrinterLocationRecord(
        location: String?
    ) {
        val newList: ArrayList<String?> = ArrayList()
        state.value.printersLocation?.forEach {
            newList.add(it?.value)
        }
        newList.add( location)

        updatePrinterLocations(
            newList = newList,
        )
    }

    private fun submitUpdateKitchenLocationRecordDialog(location: String?) {
        val newList: ArrayList<String?> = ArrayList()
        state.value.printersLocation?.forEach {
            if (it?.dbIndex == state.value.printerLocationIndex) {
                newList.add(location)
            } else newList.add(it?.value)
        }


        updatePrinterLocations(
            newList = newList,
        )
    }





    private fun getCheckoutData( ) {
        launch {
            if (state.value.cashList==null){

                val result=getSavedCheckOutUseCase()

                _state.value=_state.value.copy(
                    cashList = result?.data?.cashAssist?.children
                )
                tempCheckoutList=state.value.cashList
            }

        }

    }



    private fun searchCheckoutItems(value: String) {
        if (value.isEmpty()) {
            _state.value = _state.value.copy(cashList = tempCheckoutList)
            return
        }

        val searchTerm = value.lowercase()
        val searchedList = tempCheckoutList?.mapNotNull { model ->
            val filteredChildrenX = model.children?.mapNotNull { childX ->
                val filteredChildrenXX = childX.children?.mapNotNull { childXX ->
                    val filteredChildrenXXX = childXX.children.filter { childXXX ->
                        childXXX.name?.lowercase()?.contains(searchTerm) == true
                    }
                    if (childXX.name?.lowercase()?.contains(searchTerm) == true || filteredChildrenXXX.isNotEmpty()) {
                        childXX.copy(children = filteredChildrenXXX)
                    } else null
                }
                if (childX.name?.lowercase()?.contains(searchTerm) == true || filteredChildrenXX?.isNotEmpty() == true) {
                    childX.copy(children = filteredChildrenXX)
                } else null
            }
            if (model.name?.lowercase()?.contains(searchTerm) == true || filteredChildrenX?.isNotEmpty() == true) {
                model.copy(children = filteredChildrenX)
            } else null
        }

        _state.value = _state.value.copy(cashList = searchedList)
    }

    private fun updateAppConfig(
        title: String,
        value: List<String?>
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(isLoading = isLoading)
                },
                callRequest = {
                    updateAppConfigUseCase(
                        title = title,
                        value = value
                    )
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        appConfig = result.data?.cashAssist?.updateAppConfig
                    )
                },
                onError = { result ->
                    _state.value = _state.value.copy(
                        appConfig = state.value.appConfig
                    )
                    showRequestError(result.errors)
                },
                onException = { e ->
                    _state.value = _state.value.copy(
                        appConfig = state.value.appConfig
                    )
                    showException(e)
                }
            )
        }
    }

    private fun getAppConfig() {
        if (state.value.appConfig == null) {
            launch {
                requestHandler(
                    loadingState = { isLoading ->
                        _state.value = _state.value.copy(isLoading = isLoading)
                    },
                    callRequest = {
                        appConfigUseCase()
                    },
                    onSuccess = { result ->
                        _state.value = _state.value.copy(
                            appConfig = result.data?.cashAssist?.getAppConfig
                        )
                    },
                    onError = { result ->
                        showRequestError(result.errors)
                    },
                    onException = { e ->
                        showException(e)
                    }
                )
            }
        }
    }

    private fun updateVirtualCardInfo(
        dataTitle: String,
        dataValue: String
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(isLoading = isLoading)
                },
                callRequest = {
                    val info = state.value.virtualCardInfo
                    when (dataTitle) {
                        ApiUtils.Field.VirtualCardFields.PHONE_LINK -> {
                            val json = buildJsonObject {
                                put(ApiUtils.Field.link, dataValue)
                                put(ApiUtils.Field.description, info?.linkPhoneUri?.description)
                            }
                            updateVirtualCardInfoUseCase(
                                dataTitle = ApiUtils.Field.linkPhoneUri,
                                dataValue = json
                            )
                        }
                        ApiUtils.Field.VirtualCardFields.PHONE_DESCRIPTION -> {
                            val json = buildJsonObject {
                                put(ApiUtils.Field.description, dataValue)
                                put(ApiUtils.Field.link, info?.linkPhoneUri?.link)
                            }
                            updateVirtualCardInfoUseCase(
                                dataTitle = ApiUtils.Field.linkPhoneUri,
                                dataValue = json
                            )
                        }
                        ApiUtils.Field.VirtualCardFields.HOME_PAGE_LINK -> {
                            val json = buildJsonObject {
                                put(ApiUtils.Field.link, dataValue)
                                put(ApiUtils.Field.description, info?.homepageUri?.description)
                            }
                            updateVirtualCardInfoUseCase(
                                dataTitle = ApiUtils.Field.homepageUri,
                                dataValue = json
                            )
                        }
                        ApiUtils.Field.VirtualCardFields.HOME_PAGE_DESCRIPTION -> {
                            val json = buildJsonObject {
                                put(ApiUtils.Field.description, dataValue)
                                put(ApiUtils.Field.link, info?.homepageUri?.link)
                            }
                            updateVirtualCardInfoUseCase(
                                dataTitle = ApiUtils.Field.homepageUri,
                                dataValue = json
                            )
                        }
                        else -> {
                            updateVirtualCardInfoUseCase(
                                dataTitle = dataTitle,
                                dataValue = dataValue
                            )
                        }
                    }
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        virtualCardInfo = result.data?.cashAssist?.updateVirtualCardConfig
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun updatePrinterLocations(
        newList: ArrayList<String?>,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(addNewPrinterLocationLoading = isLoading)
                },
                callRequest = {
                    updatePrinterLocationUseCase(printerLocation = newList)
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        printersLocation = result.data.cashAssist
                            .updateAppConfig?.cashRegisterGlobal?.printerLocations
                            ?.sortedBy { it?.dbIndex },
                        showPrinterLocationRecordDialog = false,
                        printerLocationIndex = null,
                        newRecordName = ""
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun getPrintersLocation() {
        if (state.value.printersLocation == null) {
            launch {
                requestHandler(
                    loadingState = { isLoading ->
                        _state.value = _state.value.copy(isLoading = isLoading)
                    },
                    callRequest = {
                        printerLocationNamesUseCase()
                    },
                    onSuccess = { result ->
                        _state.value = _state.value.copy(
                            printersLocation = result.data.cashAssist.getAppConfig?.cashRegisterGlobal
                                ?.printerLocations?.sortedBy { it?.dbIndex }?.toList()
                        )
                    },
                    onError = { result ->
                        showRequestError(result.errors)
                    },
                    onException = { e ->
                        showException(e)
                    }
                )
            }
        }
    }

    private fun onSubmitSaleGroupRecordDialogClick(
        name: String,
        code: String,
        windowMode: WindowSizeModeEnum,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(addSalesGroupLoading = isLoading)
                },
                callRequest = {
                    addNewSaleGroupUseCase(
                        name = name,
                        accountNumber = code
                    )
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        selectedSaleGroup = result.data.cashAssist.createMutation,
                        addSalesGroupLoading = false,
                        showAddSaleGroupRecordDialog = false,
                        newRecordName = "",
                        newRecordNumber = "",
                        firstPageActive = windowMode != WindowSizeModeEnum.PHONE
                    )
                    getSalesGroup()
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun updateSaleGroup(
        dataTitle: String,
        dataValue: String,
        id: String
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(isLoading = isLoading)
                },
                callRequest = {
                    updateSaleGroupUseCase(
                        id = id,
                        dataTitle = dataTitle,
                        dataValue = dataValue
                    )
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        selectedSaleGroup = result.data.cashAssist.updateSalesGroup
                    )
                    if (dataTitle == ApiUtils.Field.acountNum || dataTitle == ApiUtils.Field.name) {
                        getSalesGroup()
                    }
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun getSalesGroup(
        onClickAction: Boolean = true
    ) {
        _state.value = _state.value.copy(addSalesGroupLoading = false)
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(isLoading = isLoading)
                },
                callRequest = {
                    salesGroupUseCase()
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        productSalesGroup = result.data.cashAssist.listSalesGroups.items
                    )
                    tempSalesGroup = result.data.cashAssist.listSalesGroups.items

                    if (state.value.productSalesGroup?.isNotEmpty() == true &&
                        state.value.selectedSaleGroup == null &&
                        onClickAction
                    ) {
                        onSaleGroupItemClick(
                            id = state.value.productSalesGroup?.get(0)?.id ?: ""
                        )
                    }
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun onSaleGroupItemClick(
        id: String,
        switchTheSecondPage: () -> Unit = {},
    ) {
        if (id != state.value.selectedSaleGroup?.id) {
            launch {
                requestHandler(
                    loadingState = { isLoading ->
                        _state.value = _state.value.copy(isLoading = isLoading)
                    },
                    callRequest = {
                        singleSaleGroupUseCase(id = id)
                    },
                    onSuccess = { result ->
                        _state.value = _state.value.copy(
                            selectedSaleGroup = result.data.cashAssist.getSalesGroup
                        )
                        switchTheSecondPage()
                    },
                    onError = { result ->
                        showRequestError(result.errors)
                    },
                    onException = { e ->
                        showException(e)
                    }
                )
            }
        } else {
            switchTheSecondPage()
        }
    }



    private fun onChangeRecordNumber(value: String) {
        _state.value=_state.value.copy(
            newRecordNumber = value
        )
        checkAddRecordSubmitClickable()
    }

    private fun onChangeRecordName(value: String?,isNumberOptional: Boolean=false) {
        _state.value=_state.value.copy(
            newRecordName = value
        )
        checkAddRecordSubmitClickable(isNumberOptional = isNumberOptional)
    }

    private fun checkAddRecordSubmitClickable(
        isNumberOptional:Boolean=false,
    ){

        val isClickable = if (isNumberOptional) {
            state.value.newRecordName?.isNotEmpty()
        } else {
            state.value.newRecordNumber.isNotEmpty() &&
                    state.value.newRecordName?.isNotEmpty()?:false
        }

        _state.value = _state.value.copy(isAddNewRecordSubmitClickable = isClickable?:false)


    }

    private fun dismissAddRecordDialog() {
        _state.value=_state.value.copy(
            showAddSaleGroupRecordDialog = false,
            showPrinterLocationRecordDialog=false,
            printerLocationIndex = null,
            isAddNewRecordSubmitClickable = false,
            newRecordName = "",
            newRecordNumber = "",
            addSalesGroupLoading = false
        )
        addNewSaleGroupUseCase.cancel()
    }

    private fun onAddRecordIconClick() {
        _state.value=_state.value.copy(
            showAddSaleGroupRecordDialog = true
        )
    }




    private fun changePage() {
        _state.value=_state.value.copy(
            firstPageActive = !_state.value.firstPageActive,
        )
    }


    private fun onSaleGroupNumberSortClick() {

        val newData:List<SaleItem>
        if (_state.value.isSaleGroupNumberSortedAsc) {
            newData=_state.value.productSalesGroup?.sortedByDescending { it.acountNum }?.toList()?: listOf()
        }else{
            newData=_state.value.productSalesGroup?.sortedBy { it.acountNum }?.toList()?: listOf()
        }
        _state.value=_state.value.copy(
            productSalesGroup = newData,
            isSaleGroupNumberSortedAsc =!_state.value.isSaleGroupNumberSortedAsc,
            showSaleGroupNumberSortIcon = true,
            showSaleGroupTitleSortIcon = false
        )
    }

    private fun onSaleGroupTitleSortClick() {
        val newData:List<SaleItem>
        if (_state.value.isSaleGroupNameSortedAsc) {
            newData= _state.value.productSalesGroup?.
                sortedByDescending { it.name.lowercase() }?.toList()?: listOf()
        }else{
            newData= _state.value.productSalesGroup?.
                sortedBy { it.name.lowercase() }?.toList()?: listOf()
        }
        _state.value=_state.value.copy(
            productSalesGroup = newData,
            isSaleGroupNameSortedAsc =!_state.value.isSaleGroupNameSortedAsc,
            showSaleGroupTitleSortIcon = true,
            showSaleGroupNumberSortIcon = false
        )
    }

    private fun onSearchSaleGroupInputChange(value: String) {
        _state.value= _state.value.copy(productSalesGroup =tempSalesGroup )
        val newData=_state.value.productSalesGroup?.filter {model ->
            model.name.contains(value, ignoreCase = true) ||
            model.acountNum?.contains(value, ignoreCase = true)==true
        }
        _state.value=_state.value.copy(
            productSalesGroup = newData
        )

    }




    private fun saveCompanyProfileId(id: String?) {
        if (id!=null){
            try {
                saveCompanyProfileIdUseCase(id = id)
            }catch (e:Exception){
                showException(e)
            }
        }

    }

    private fun updateOptionData(
        dataTitle: String,
        dataValue: dynamic,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(isLoading = isLoading)
                },
                callRequest = {
                    val result = updateOptionUseCase(
                        dataTitle = dataTitle,
                        dataValue = dataValue
                    )

                    if (dataTitle == ApiUtils.Field.countryId) {
                        saveCompanyProfileId(dataValue as String)
                    }

                    // Setting defaultValues for new customer
                    if (dataTitle == ApiUtils.Field.name
                        && dataValue is String
                        && state.value.optionModel?.name?.isEmpty() == true
                    ) {
                        val isNewCustomer = (dataValue as String).isEmpty()

                        setNewCustomerUseCase(newCustomer = isNewCustomer)

                        addProductUseCase(
                            name = Constants.AppDefaultValues.productName,
                            code = Constants.AppDefaultValues.productNumber,
                            price = Constants.AppDefaultValues.productPrice,
                            saleGroupId = Constants.AppDefaultValues.salesGroupId
                        ).data?.cashAssist?.createMutation

                        addCategoryUseCase(
                            name = Constants.AppDefaultValues.templateName,
                            position = Constants.AppDefaultValues.templatePosition
                        ).data?.cashAssist?.createMutation

                        addNewSaleGroupUseCase(
                            name = Constants.AppDefaultValues.salesGroupReceipeName,
                            accountNumber = Constants.AppDefaultValues.salesGroupNumber
                        ).data.cashAssist.createMutation

                        val configList = listOf<String?>(
                            Constants.AppDefaultValues.optionCashFlowName1,
                            null,
                            Constants.AppDefaultValues.optionCashFlowName3,
                            null,
                            Constants.AppDefaultValues.optionCashFlowName5,
                            null, null, null, null, null
                        )
                        updateAppConfig(
                            title = ApiUtils.Field.creditCards,
                            value = configList
                        )

                        val newList: ArrayList<String?> = ArrayList()
                        newList.add(Constants.AppDefaultValues.printerLocation1Name)
                        newList.add(Constants.AppDefaultValues.printerLocation2Name)
                        updatePrinterLocationUseCase(printerLocation = newList)

                        _state.value = _state.value.copy(
                            areTabsClickable = true
                        )
                    }

                    result
                },
                onSuccess = { result ->
                    loadOperationData()
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun loadOperationData() {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(isLoading = isLoading)
                },
                callRequest = {
                    optionsDataUseCase()
                },
                onSuccess = { result ->
                    val isNewCustomer = result.data?.cashAssist?.getAppConfig
                        ?.name?.isEmpty() ?: true
                    _state.value = _state.value.copy(
                        optionModel = result.data?.cashAssist?.getAppConfig,
                        areTabsClickable = !isNewCustomer
                    )
                    launch {
                        setNewCustomerUseCase(
                            newCustomer = isNewCustomer
                        )
                    }

                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun generateMenuCard(
        email: String,
        files: List<File>
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(isMenuCardAIGeneratorLoading = isLoading)
                },
                callRequest = {
                    var result = getMenuCardUseCase(email = email, files = files)

                    if (result.startsWith("\"") && result.endsWith("\"")) {
                        result = result.substring(1, result.length - 1).replace("\\", "")
                    }

                    result
                },
                onSuccess = { result ->
                    val menuCard = Json.decodeFromString<MenuCardModel>(result)
                    _state.value = _state.value.copy(
                        showGenerateAIMenuCardDialog = false,
                        menuCardAIGenerated = menuCard,
                        menuCardPDFFilesUploaded = 0,
                        menuCardImageFilesUploaded = 0,
                        menuCardSelectedFiles = emptyList()
                    )
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun saveMenuCard(
        menuCard: MenuCardModel,
        ingredients: List<Ingredients>?
    ) {
        val selectedItems = menuCard.items
            .filter { it.selected == true }.distinct().toMutableList()

        menuCard.categories = selectedItems
            .mapNotNull { it.category }
            .distinct()
            .toMutableList()

        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(
                        isLoading = isLoading,
                        clearMenuCardDataLoading = isLoading,
                        dataLoadingProgressTitle = if (isLoading)
                            LanguageManager.getCurrentStrings().dataLoadingProgressCategoryImportTitle
                        else ""
                    )
                },
                callRequest = {
                    val categoryIds = menuCard.categories.mapNotNull { categoryName ->
                        val existing = state.value.templateCategoryList.firstOrNull {
                            it.name?.trim()?.equals(categoryName.trim(), ignoreCase = true) == true
                        }
                        existing?.id ?: addCategoryUseCase(name = categoryName).data?.cashAssist?.createMutation?.id
                    }

                    val ingredientIds: List<List<String>> = selectedItems.map { product ->
                        product.allergens.orEmpty().mapNotNull { allergenName ->
                            val allergenEnum = AllergensEnum.entries.firstOrNull {
                                it.english.equals(allergenName, ignoreCase = true) ||
                                        it.german.equals(allergenName, ignoreCase = true)
                            }
                            val matchingIngredient = ingredients?.firstOrNull { ingredient ->
                                val name = ingredient.name?.trim()
                                name.equals(allergenEnum?.english, ignoreCase = true) ||
                                        name.equals(allergenEnum?.german, ignoreCase = true)
                            }

                            matchingIngredient?.id ?: "-1"
                        }
                    }

                    val turnoverGroupIds = selectedItems.map { product ->
                        state.value.productSalesGroup?.firstOrNull {
                            it.acountNum?.trim()?.equals(
                                product.turnoverGroup?.let {
                                    Regex("""\d+""").find(it)?.value ?: "1009"
                                } ?: "1009",
                                ignoreCase = true
                            ) == true
                        }?.id
                    }

                    val productLocationIds: List<List<Boolean>> = selectedItems.map { product ->
                        val matchStrings = buildList {
                            if (product.kuchen == true) add("küche")
                            if (product.buffet == true) add("buffet")
                        }

                        if (matchStrings.isEmpty()) {
                            List((state.value.printersLocation ?: emptyList()).size) { false }
                        } else {
                            state.value.printersLocation?.map { printerLocation ->
                                printerLocation?.value?.let { printerValue ->
                                    matchStrings.any { matchString ->
                                        printerValue.equals(matchString, ignoreCase = true)
                                    }
                                } == true
                            } ?: emptyList()
                        }
                    }

                    val productIds = upsertProductsUseCase(
                        menuCard = menuCard.copy(items = selectedItems),
                        categoryIds = categoryIds,
                        ingredientIds = ingredientIds,
                        turnoverGroupIds = turnoverGroupIds,
                        productLocationIds = productLocationIds
                    )

                    var index = 0
                    for (pair in productIds.data?.cashAssist?.upsertProducts!!.zip(selectedItems)) {
                        index++
                        if (index % 5 == 0) {
                            _state.value = _state.value.copy(
                                dataLoadingProgressTitle =
                                "${min(index, selectedItems.size)}/${selectedItems.size} " +
                                        "${LanguageManager.getCurrentStrings().products.lowercase()} " +
                                        LanguageManager.getCurrentStrings().uploaded
                            )
                        }

                        updateProductPropertiesUseCase(
                            productId = pair.first.id,
                            isAlcohol = pair.second.alcoholic,
                            isVegan = pair.second.vegan,
                            isVegetarian = pair.second.vegetarian
                        )
                    }

                    _state.value = _state.value.copy(
                        dataLoadingProgressTitle = LanguageManager.getCurrentStrings()
                            .dataLoadingProgressMenuCardImportTitle
                    )

                    productIds
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        menuCardAIGenerated = MenuCardModel(
                            categories = mutableListOf(),
                            items = mutableListOf()
                        ),
                        menuCardPDFFilesUploaded = 0,
                        menuCardImageFilesUploaded = 0,
                        menuCardSelectedFiles = emptyList(),
                        dataLoadingProgressTitle = ""
                    )
                },
                onError = { result ->
                    _state.value = _state.value.copy(
                        menuCardAIGenerated = MenuCardModel(
                            categories = mutableListOf(),
                            items = mutableListOf()
                        ),
                        menuCardPDFFilesUploaded = 0,
                        menuCardImageFilesUploaded = 0,
                        menuCardSelectedFiles = emptyList()
                    )
                    showRequestError(result.errors)
                },
                onException = { e ->
                    _state.value = _state.value.copy(
                        menuCardAIGenerated = MenuCardModel(
                            categories = mutableListOf(),
                            items = mutableListOf()
                        ),
                        menuCardPDFFilesUploaded = 0,
                        menuCardImageFilesUploaded = 0,
                        menuCardSelectedFiles = emptyList()
                    )
                    showException(e)
                }
            )
        }
    }

    private fun onGenerateMenuCardButtonClick() {
        _state.value=_state.value.copy(
            showGenerateAIMenuCardDialog = true
        )
    }

    private fun onMenuProductItemValueChange(
        menuCard:MenuCardModel,
        id:Int,
        key:String,
        value:String
    ) {
        menuCard.items[id] = menuCard.items[id].let { item ->
            when (key) {
                MenuCardEnum.Name.title -> item.copy(name = value)
                MenuCardEnum.Description.title -> item.copy(description = value)
                MenuCardEnum.Price.title -> item.copy(price = value.ifBlank { "0" })
                MenuCardEnum.Weight.title -> item.copy(weight = value)
                MenuCardEnum.Allergens.title -> item.copy(allergens = value.split(",")
                    .map(String::trim))
                MenuCardEnum.Category.title -> item.copy(category = value)
                MenuCardEnum.TurnoverGroup.title -> item.copy(turnoverGroup = value)
                //MenuCardEnum.Template.title -> item.copy(template = value)
                MenuCardEnum.Ingredients.title -> item.copy(ingredients = value)
                MenuCardEnum.Kuchen.title -> item.copy(kuchen = value.toBoolean())
                MenuCardEnum.Buffet.title -> item.copy(buffet = value.toBoolean())
                MenuCardEnum.Alcoholic.title -> item.copy(alcoholic = value.toBoolean())
                MenuCardEnum.Vegan.title -> item.copy(vegan = value.toBoolean())
                MenuCardEnum.Vegetarian.title -> item.copy(vegetarian = value.toBoolean())
                MenuCardEnum.Selected.title -> item.copy(selected = value.toBoolean())
                MenuCardEnum.ProductNumber.title -> item.copy(productNumber = value)
                else -> item
            }
        }
        _state.value=_state.value.copy(
            menuCardAIGenerated = menuCard,
        )
    }

    private fun getIngredients() {
        launch {
            if (state.value.ingredients == null) {
                requestHandler(
                    loadingState = { isLoading ->
                        _state.value = _state.value.copy(isLoading = isLoading)
                    },
                    callRequest = {
                        ingredientListUseCase()
                    },
                    onSuccess = { result ->
                        _state.value = _state.value.copy(
                            ingredients = result.data.cashAssist.listIngredients
                        )
                    },
                    onError = { result ->
                        showRequestError(result.errors)
                    },
                    onException = { e ->
                        showException(e)
                    }
                )
            }
        }
    }

    private fun getTemplateCategoryList() {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(isLoading = isLoading)
                },
                callRequest = {
                    getTemplateCategoriesUseCase()
                },
                onSuccess = { result ->
                    val sortedCategories = defaultCategorySorting(
                        result.data?.cashAssist?.listCategories?.items ?: listOf()
                    )

                    _state.value = _state.value.copy(templateCategoryList = sortedCategories)
                    if (_state.value.templateCategoryListDropDown ==
                        mutableListOf<TemplateCategoryModel>()) {
                        _state.value = _state.value.copy(templateCategoryListDropDown =
                        sortedCategories.toMutableList())
                    }
                },
                onException = { e ->
                    console.log(e.toString())
                    showException(e)
                }
            )
        }
    }


    private fun updateTemplateCategoryList(
        categoriesDropDown: MutableList<TemplateCategoryModel>,
        menuCard: MenuCardModel
    )
    {
        val existingNames = categoriesDropDown.mapNotNull { it.name?.trim()?.lowercase() }.toSet()
        menuCard.categories
            .map {
                it.trim()
            }
            .filter {
                it.lowercase() !in existingNames
            }
            .forEach { newName ->
                categoriesDropDown.add(TemplateCategoryModel(id = "NEW",
                    name = newName, position = 0, isActive = false))
            }
        _state.value=_state.value.copy(templateCategoryListDropDown =
        defaultCategorySorting(categoriesDropDown).toMutableList())
    }

    private fun defaultCategorySorting(data: List<TemplateCategoryModel>):
            List<TemplateCategoryModel>
    {
        return data.sortedBy { it.position }
    }

    private fun showRequestError(result:List<GeneralError?>?) {
        _state.value = _state.value.copy(
            errorInfo = errorMessage(result)
        )
    }
    private fun showException(e: Exception) {
        if (!e.toString().contains(ApiUtils.Status.ERR_401)){
            _state.value = _state.value.copy(
                errorInfo = e.message.toString()
            )
        }
    }

}




